import equal from '../../node_modules/fast-deep-equal/index.js';
import { isUndefined, isNullOrUndefined, isEmptyArray } from '../guards/index.js';

const pick = (object, keys) => {
  return keys.reduce((acc, key) => {
    acc[key] = object[key];
    return acc;
  }, {});
};
const omit = (object, keys) => {
  const clone = {
    ...object
  };
  keys.forEach((key) => delete clone[key]);
  return clone;
};
const omitUndefined = (object) => {
  const clone = {
    ...object
  };
  Object.entries(clone).forEach(([key, value]) => {
    if (value === void 0) {
      delete clone[key];
    }
  });
  return clone;
};
const omitPropertiesBase = (object, shouldOmitFn) => {
  const clone = {
    ...object
  };
  Object.entries(clone).forEach(([key, value]) => {
    if (Array.isArray(shouldOmitFn) ? shouldOmitFn.some((fn) => fn(value)) : shouldOmitFn(value)) {
      delete clone[key];
    }
  });
  return clone;
};
const omitProperties = Object.assign(omitPropertiesBase, {
  isEmptyArray,
  isNullOrUndefined,
  isUndefined
});
function diffChange(newVal) {
  return (oldVal) => {
    const isEqual = equal(oldVal, newVal);
    return isEqual ? oldVal : newVal;
  };
}
function sanitizeForLogging(obj, options = {}) {
  const {
    maxStringLength = 5e3,
    maxArrayLength = 50,
    maxObjectKeys = 50,
    maxDepth = 15
  } = options;
  const seen = /* @__PURE__ */ new WeakSet();
  function helper(value, depth) {
    if (depth > maxDepth) {
      return "[Max depth reached]";
    }
    if (value === null || typeof value !== "object") {
      if (typeof value === "string") {
        return value.length > maxStringLength ? value.slice(0, maxStringLength) + "... [truncated]" : value;
      }
      return value;
    }
    if (seen.has(value)) {
      return "[Circular]";
    }
    seen.add(value);
    if (Array.isArray(value)) {
      const length2 = Math.min(value.length, maxArrayLength);
      const result2 = value.slice(0, length2).map((item) => helper(item, depth + 1));
      if (value.length > length2) {
        result2.push(`... [${value.length - length2} more items]`);
      }
      return result2;
    }
    if (value instanceof Uint8Array) {
      return `[Uint8Array length=${value.length}]`;
    }
    const keys = Object.keys(value);
    const length = Math.min(keys.length, maxObjectKeys);
    const result = {};
    for (let i = 0; i < length; i++) {
      const key = keys[i];
      result[key] = helper(value[key], depth + 1);
    }
    if (keys.length > length) {
      result["..."] = `[${keys.length - length} more keys]`;
    }
    return result;
  }
  return helper(obj, 0);
}

export { diffChange, omit, omitProperties, omitUndefined, pick, sanitizeForLogging };
//# sourceMappingURL=manipulation.js.map
